import React from "react";

const Orders = () => {
  return (
    <>
      <div className="col-md-9">
        <div className="grid-layout wrapper-shop">
          <div className="tf-login-content">
            <div className="table-responsive">
              <table className="table" id="datatable">
                <thead>
                  <tr>
                    <th scope="col" className="no-sort">
                      Order
                    </th>
                    <th scope="col" className="no-sort">
                      Date
                    </th>
                    <th scope="col" className="no-sort">
                      Status
                    </th>
                    <th scope="col" className="no-sort">
                      Total
                    </th>
                    <th scope="col" className="no-sort">
                      &nbsp;
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row">#55</td>
                    <td>November 10, 2024</td>
                    <td>0</td>
                    <td>KWD 125.683</td>
                    <td>
                      <a
                        href="https://uat.webykw.com/orders/55"
                        className="btn view-btn"
                      >
                        View
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
